<template>

    <v-menu v-if="editable"
            offset-y
            :top="!showUnder"
            :bottom="showUnder"
            :close-on-content-click="false"
            :close-on-click="true"
            :nudge-bottom="showUnder ? 10 : 0"
            :nudge-top="!showUnder ? 10 : 0"
            max-width="600"
            v-model="editorModel">

        <template v-slot:activator="{ on }">

            <v-tooltip top color="primary" :open-delay="400" :close-delay="400">
                <template v-slot:activator="{ on }">

                    <span v-on="on" @click="clickedActivator" class="cursor-pointer">
                        <slot></slot>
                    </span>
                </template>
                <span>Click here to edit</span>
            </v-tooltip>

        </template>

        <v-card color="white" style="opacity: 0.95;">

            <v-card-text class="pt-0">

                <v-textarea
                        light
                        auto-grow
                        row-height="24"
                        v-model="textModel"
                        :hint="hint"
                        persistent-hint
                        class="mt-0"
                        :rows="recommendedRows"
                        @keydown.enter.prevent="enterPressed"
                >
                </v-textarea>
            </v-card-text>
        </v-card>

    </v-menu>
    <div v-else>
        <slot></slot>
    </div>

</template>

<script>
    import VueMarkdown from '@adapttive/vue-markdown';

    export default {

        components: {
            VueMarkdown
        },

        props: {
            value: {
                type: String | null,
                required: true,
            },
            hint: {
                type: String,
                required: false,
                default: '',
            },
            markdown: {
                type: Boolean,
                required: false,
                default: false,
            },
            showUnder: {
                type: Boolean,
                required: false,
                default: false,
            },
            editable: {
                type: Boolean,
                required: false,
                default: true,
            }
        },

        data() {
            return {
                markdownInfoLink: '<a class="white--text" href="https://www.markdownguide.org/basic-syntax/#overview" target="_blank">More info</a>',
                editorModel: false,
            }
        },

        computed: {

            textModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },
            recommendedRows() {
                if (typeof this.value === 'undefined') return 1;
                if (this.value === null) return 1;
                let lines = Math.ceil(this.value.length / 80);
                if (lines > 1) lines++;
                return lines;
            }
        },

        methods: {
            enterPressed() {
                this.editorModel = false;
            },

            clickedActivator() {
                this.editorModel = true;
            }
        }
    }
</script>
